<div style="height: 85vh; width: 99%; margin-left: 0.5%;">
  <table cellpadding="0"
    style="width: 50%;  border-color: silver;  border-width: 1px; border-style:solid; padding-left:50px; margin: auto;">
    <tr class="sectionHeader">
      <td colspan="2" style="text-align:center; color: #6D677E;"> Select an option</td>
    </tr>
    <tr>
      <td align="center" style="width:50%; padding-bottom: 50px;">
        <button routerLink="/data/run/extracts" class="button-redirect">RUN Data Extract</button>
      </td>
      <td align="center" style="width:50%; padding-bottom: 50px;"  >
        <button routerLink="/data/add/extract" class="button-redirect">ADD/EDIT Data Extract</button>
      </td>
    </tr>
  </table>
</div>